module.exports = __webpack_public_path__ + "static/example_1_day_with_week_grid-f9527ac56e1017279679318c684c2110.png";